var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondsLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 11,
    fill: "#12101A",
    stroke: "#A046D3",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6199_60331)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0001 24.0015C28.9047 24.0015 24.0001 28.906 24.0001 30.0015C24.0001 28.906 19.0956 24.0015 18.0001 24.0015C19.0956 24.0015 24.0001 19.0969 24.0001 18.0015C24.0001 19.0969 28.9047 24.0015 30.0001 24.0015Z",
    fill: "#A046D3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6199_60331"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.7143,
    height: 13.7143,
    fill: "white",
    transform: "translate(17.1431 17.1445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondsLoader);
export default __webpack_public_path__ + "static/media/diamondsLoader.44782098610a900e585857bc6200c0c7.svg";
export { ForwardRef as ReactComponent };